import React from 'react';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full py-6 bg-blue-900 text-white animate-fadeIn">
      <div className="container mx-auto px-6 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex flex-col text-sm">
          <h3 className="font-bold mb-2">CONTÁCTANOS</h3>
          <div className="flex items-center mb-1">
            <MapPin className="mr-2 h-4 w-4" />
            Sargento Candelaria 290, Villa Alemana, Región de Valparaíso.
          </div>
          <div className="flex items-center mb-1">
            <Phone className="mr-2 h-4 w-4" />
            (32) 2731164
          </div>
          <div className="flex items-center mb-1">
            <Phone className="mr-2 h-4 w-4" />
            +56 9 5739 6243
          </div>
          <div className="flex items-center mb-1">
            <Mail className="mr-2 h-4 w-4" />
            secretaria@elarcoiris.cl
          </div>
          <div className="flex items-center mb-1">
            <Clock className="mr-2 h-4 w-4" />
            Horarios de atención: 8:30 a 12:30 y de 14:00 a 17:30 hrs.
          </div>
        </div>
        

        
        <div className="flex gap-4 mt-4 sm:mt-0">
          <a
            href="https://www.facebook.com/elarcoirisva"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook de Escuela de Lenguaje Arcoíris"
            className="text-white hover:text-gray-300 transition-colors"
          >
            <Facebook className="w-6 h-6" />
          </a>
          <a
            href="https://www.instagram.com/elarcoiris_va/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram de Escuela de Lenguaje Arcoíris"
            className="text-white hover:text-gray-300 transition-colors"
          >
            <Instagram className="w-6 h-6" />
          </a>
        </div>
      </div>
      
      <div className="w-full text-center mt-8 pt-4 border-t border-blue-800 text-sm text-gray-300">
        <p>
          Página web desarrollada por{' '}
          <a 
            href="https://integria.cl" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="font-semibold hover:text-white transition-colors underline decoration-dotted"
          >
            IntegrIA
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
